import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { GuideQuestionForm } from "src/app/models/guide-question-form.model";
import { GuideQuestionFormComponent } from "./guide-question-form.component";

export interface GuideQuestionFormDialogData {
  form: GuideQuestionForm;
  flowId: string;
  formKey: string;
  stepIndex?: number | null;
  sessionId?: string | null;
  flowVersion?: number | null;
  submitLabel?: string;
}

/** Closes with "submitted" or "skipped" when the viewer may move on, or undefined when they stay on the step. */
export type GuideQuestionFormDialogResult = "submitted" | "skipped" | undefined;

@Component({
  selector: "app-guide-question-form-dialog",
  standalone: true,
  imports: [CommonModule, MatDialogModule, GuideQuestionFormComponent],
  template: `
    <div class="gqfd">
      <app-guide-question-form
        variant="dialog"
        [form]="data.form"
        [flowId]="data.flowId"
        [formKey]="data.formKey"
        [stepIndex]="data.stepIndex ?? null"
        [sessionId]="data.sessionId ?? null"
        [flowVersion]="data.flowVersion ?? null"
        [submitLabel]="data.submitLabel || 'Submit and continue'"
        (submitted)="dialogRef.close('submitted')"
        (skipped)="dialogRef.close('skipped')"
        (cancelled)="dialogRef.close()"
      ></app-guide-question-form>
    </div>
  `,
  styles: [
    `
      .gqfd { background: #fff; border-radius: 22px; overflow: hidden; box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35); }
      :host-context(body.theme-dark) .gqfd { background: #111827; }
      @media (max-width: 640px) { .gqfd { border-radius: 16px; } }
    `,
  ],
})
export class GuideQuestionFormDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<GuideQuestionFormDialogComponent, GuideQuestionFormDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: GuideQuestionFormDialogData
  ) {}

  static open(dialog: MatDialog, data: GuideQuestionFormDialogData): Observable<GuideQuestionFormDialogResult> {
    return dialog
      .open<GuideQuestionFormDialogComponent, GuideQuestionFormDialogData, GuideQuestionFormDialogResult>(
        GuideQuestionFormDialogComponent,
        {
          data,
          width: "min(600px, 96vw)",
          maxWidth: "96vw",
          panelClass: "dialoguebox",
          autoFocus: false,
          disableClose: true,
        }
      )
      .afterClosed();
  }
}
